var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    svg { cursor: default;}\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1149 -732)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1149 732)",
    fill: "#0b3a5d",
    stroke: "#0b3a5d",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none",
    shapeRendering: "geometricPrecision"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1154 748)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionOutline);
export default __webpack_public_path__ + "static/media/question-outline.51707afab4614ce42d8394dc06f594b0.svg";
export { ForwardRef as ReactComponent };